import { getUserRole } from "../../userLocalDetails"

export const isShowLink = () => {
    return getUserRole() === 'TEACHER';
}

export const getEffectiveSelectedIndex = (selectedIndex, items) => {
    return selectedIndex !== undefined && selectedIndex !== null
      ? selectedIndex
      : (items && items.length > 0 ? 0 : -1);
  };
  
  export const getEffectiveCurrentFieldId = (currentFieldId, items) => {
    return currentFieldId !== undefined && currentFieldId !== null
      ? currentFieldId
      : (items && items.length > 0 && items[0].id ? items[0].id : null);
  };

export const isMarkingCriteria = (itemType) => {
    return itemType === 'Marking Template';
};

export const isSuccessCriteria = (itemType) => {
    return itemType === 'Success Criteria' || itemType === 'Success Criterias';
};

export const isShortAnswer = (itemType) => {
    return itemType === 'Short Answers';
};

export const isCommentBank = (itemType) => {
    return itemType === 'Comment Bank';
};

export const getItemTypeDisplay = (itemType) => {
    if (isMarkingCriteria(itemType)) {
        return 'Rubric';
    }
    if (isSuccessCriteria(itemType)) {
        return 'Success Criteria';
    }
    if (isShortAnswer(itemType)) {
        return 'Short Answer';
    }
    return 'Comment Bank';
};